import $ from 'jquery';

class cdpStatisticsProfilesWithPhone{
  constructor() {
    if ($('#cdp-stat-profiles-with-phone').length > 0){
      this.loading()
      this.init()
    }
  }

  init(){
    var cdpStat = this;
    $(document).ready(function() {
      setTimeout(function() {
        var result = { query: JSON.stringify(SegmentQueryBuilder.getMongoQuery()) };
        $.ajax({
          url: $('#cdp-stat-profiles-with-phone').data('url'),
          method: 'GET',
          data: result,
          success: function (response) {
            cdpStat.renderStats(response)
          }
        });
      }, 1000);
    })
  }

  renderStats(response){
    $('#cdp-stat-profiles-with-phone h6').text(`${this.transform(response.profiles_count)} (${this.transform(response.profiles_percentage)}%)`);
    this.loaded();
  }

  loading(){
    $('#cdp-stat-profiles-with-phone').addClass('loading');
  }

  loaded(){
    $('#cdp-stat-profiles-with-phone').removeClass('loading');
  }

  transform(number) {
    return parseFloat(number).toLocaleString("ru")
  }
}

export default cdpStatisticsProfilesWithPhone;